// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-carousel {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 12px 0;
  width: 100%;
}

.carousel-main {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 12px;
  background: var(--bg-tertiary);
}

.carousel-image {
  max-width: 60% !important;
  max-height: 400px;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}

.single-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0;
}

.single-image {
  max-width: 60% !important;
  max-height: 400px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
}

.carousel-image-title {
  text-align: center;
  font-size: 0.82rem;
  font-weight: 700;
  color: var(--text-secondary);
  letter-spacing: 0.03em;
  text-transform: uppercase;
}

/* Navigation Arrows */
.carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.6);
  border: none;
  color: var(--accent-hover);
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  transition: background 0.2s ease;
  width: 40px;
  height: 40px;
}

.carousel-nav:hover {
  background: rgba(0, 0, 0, 0.8);
}

.carousel-nav svg {
  width: 20px;
  height: 20px;
}

.carousel-prev {
  left: 10px;
}

.carousel-next {
  right: 10px;
}

/* Image Counter */
.carousel-counter {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.7);
  color: var(--accent-hover);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  z-index: 10;
}

/* Dot Navigation */
.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background: #ccc;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  outline: none;
}

.dot:hover {
  background: #999;
}

.dot.active {
  background: #1da1f2;
  width: 24px;
  border-radius: 4px;
}

/* Lightbox Styles */
.lightbox-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--shadow-strong);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.lightbox-container {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-image {
  max-width: 100%;
  max-height: 90vh;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 8px;
  -webkit-user-select: none;
          user-select: none;
  background: repeating-conic-gradient(#808080 0 25%, #FFF 0 50%) 50% / 20px 20px;
  padding: 2vh;
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: var(--shadow-strong);
  border: none;
  color: white;
  font-size: 32px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s ease;
  z-index: 10001;
}

.lightbox-close:hover {
  filter: invert(100%);
  transition: 0.3s; /* Adds a smooth transition */
}

.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: var(--shadow-strong);
  border: none;
  color: white;
  font-size: 40px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.2s ease;
  z-index: 10000;
}

.lightbox-nav:hover {
  filter: invert(100%);
  transition: 0.3s; /* Adds a smooth transition */
}

.lightbox-prev {
  left: 20px;
}

.lightbox-next {
  right: 20px;
}

.lightbox-counter {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: var(--overlay-strong);
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  z-index: 10001;
}

/* Mobile Lightbox */
@media (max-width: 768px) {
  .lightbox-nav {
    width: 50px;
    height: 50px;
    font-size: 32px;
  }

  .lightbox-prev {
    left: 10px;
  }

  .lightbox-next {
    right: 10px;
  }

  .lightbox-close {
    width: 45px;
    height: 45px;
    font-size: 28px;
    top: 10px;
    right: 10px;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .carousel-image,
  .single-image {
    max-width: 80%;
    max-height: 300px;
  }

  .carousel-nav {
    width: 36px;
    height: 36px;
    padding: 6px 10px;
  }

  .carousel-nav svg {
    width: 18px;
    height: 18px;
  }

  .carousel-prev {
    left: 6px;
  }

  .carousel-next {
    right: 6px;
  }
}

@media (max-width: 480px) {
  .carousel-image,
  .single-image {
    max-width: 90%;
    max-height: 250px;
  }

  .carousel-counter {
    top: 8px;
    right: 8px;
    font-size: 11px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageCarousel/ImageCarousel.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gCAAgC;EAChC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,+EAA+E;EAC/E,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,WAAW;EACb;AACF;;AAEA,sBAAsB;AACtB;EACE;;IAEE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[".image-carousel {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin: 12px 0;\r\n  width: 100%;\r\n}\r\n\r\n.carousel-main {\r\n  position: relative;\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  overflow: hidden;\r\n  border-radius: 12px;\r\n  background: var(--bg-tertiary);\r\n}\r\n\r\n.carousel-image {\r\n  max-width: 60% !important;\r\n  max-height: 400px;\r\n  width: auto;\r\n  height: auto;\r\n  object-fit: contain;\r\n  display: block;\r\n}\r\n\r\n.single-image-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 12px 0;\r\n}\r\n\r\n.single-image {\r\n  max-width: 60% !important;\r\n  max-height: 400px;\r\n  width: auto;\r\n  height: auto;\r\n  object-fit: contain;\r\n  border-radius: 8px;\r\n}\r\n\r\n.carousel-image-title {\r\n  text-align: center;\r\n  font-size: 0.82rem;\r\n  font-weight: 700;\r\n  color: var(--text-secondary);\r\n  letter-spacing: 0.03em;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* Navigation Arrows */\r\n.carousel-nav {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: rgba(0, 0, 0, 0.6);\r\n  border: none;\r\n  color: var(--accent-hover);\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10;\r\n  transition: background 0.2s ease;\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n\r\n.carousel-nav:hover {\r\n  background: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.carousel-nav svg {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.carousel-prev {\r\n  left: 10px;\r\n}\r\n\r\n.carousel-next {\r\n  right: 10px;\r\n}\r\n\r\n/* Image Counter */\r\n.carousel-counter {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  color: var(--accent-hover);\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  z-index: 10;\r\n}\r\n\r\n/* Dot Navigation */\r\n.carousel-dots {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: #ccc;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  padding: 0;\r\n  outline: none;\r\n}\r\n\r\n.dot:hover {\r\n  background: #999;\r\n}\r\n\r\n.dot.active {\r\n  background: #1da1f2;\r\n  width: 24px;\r\n  border-radius: 4px;\r\n}\r\n\r\n/* Lightbox Styles */\r\n.lightbox-backdrop {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: var(--shadow-strong);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n  animation: fadeIn 0.2s ease;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.lightbox-container {\r\n  position: relative;\r\n  max-width: 90vw;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.lightbox-image {\r\n  max-width: 100%;\r\n  max-height: 90vh;\r\n  width: auto;\r\n  height: auto;\r\n  object-fit: contain;\r\n  border-radius: 8px;\r\n  user-select: none;\r\n  background: repeating-conic-gradient(#808080 0 25%, #FFF 0 50%) 50% / 20px 20px;\r\n  padding: 2vh;\r\n}\r\n\r\n.lightbox-close {\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  background: var(--shadow-strong);\r\n  border: none;\r\n  color: white;\r\n  font-size: 32px;\r\n  width: 50px;\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background 0.2s ease;\r\n  z-index: 10001;\r\n}\r\n\r\n.lightbox-close:hover {\r\n  filter: invert(100%);\r\n  transition: 0.3s; /* Adds a smooth transition */\r\n}\r\n\r\n.lightbox-nav {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: var(--shadow-strong);\r\n  border: none;\r\n  color: white;\r\n  font-size: 40px;\r\n  width: 60px;\r\n  height: 60px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  border-radius: 4px;\r\n  transition: background 0.2s ease;\r\n  z-index: 10000;\r\n}\r\n\r\n.lightbox-nav:hover {\r\n  filter: invert(100%);\r\n  transition: 0.3s; /* Adds a smooth transition */\r\n}\r\n\r\n.lightbox-prev {\r\n  left: 20px;\r\n}\r\n\r\n.lightbox-next {\r\n  right: 20px;\r\n}\r\n\r\n.lightbox-counter {\r\n  position: absolute;\r\n  bottom: 20px;\r\n  right: 20px;\r\n  background: var(--overlay-strong);\r\n  color: white;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  z-index: 10001;\r\n}\r\n\r\n/* Mobile Lightbox */\r\n@media (max-width: 768px) {\r\n  .lightbox-nav {\r\n    width: 50px;\r\n    height: 50px;\r\n    font-size: 32px;\r\n  }\r\n\r\n  .lightbox-prev {\r\n    left: 10px;\r\n  }\r\n\r\n  .lightbox-next {\r\n    right: 10px;\r\n  }\r\n\r\n  .lightbox-close {\r\n    width: 45px;\r\n    height: 45px;\r\n    font-size: 28px;\r\n    top: 10px;\r\n    right: 10px;\r\n  }\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .carousel-image,\r\n  .single-image {\r\n    max-width: 80%;\r\n    max-height: 300px;\r\n  }\r\n\r\n  .carousel-nav {\r\n    width: 36px;\r\n    height: 36px;\r\n    padding: 6px 10px;\r\n  }\r\n\r\n  .carousel-nav svg {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n\r\n  .carousel-prev {\r\n    left: 6px;\r\n  }\r\n\r\n  .carousel-next {\r\n    right: 6px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .carousel-image,\r\n  .single-image {\r\n    max-width: 90%;\r\n    max-height: 250px;\r\n  }\r\n\r\n  .carousel-counter {\r\n    top: 8px;\r\n    right: 8px;\r\n    font-size: 11px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
